"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeBlock = void 0;
const react_1 = __importStar(require("react"));
const react_range_1 = require("react-range");
const range_styled_1 = require("./range.styled");
const vobaza_ui_inputs_input_text_1 = require("@nebo-team-dev/vobaza.ui.inputs.input-text");
const vobaza_ui_button_1 = require("@nebo-team-dev/vobaza.ui.button");
function RangeBlock({ step = 1, min = 0, max = 1000, incomeValues, setIncomeValue, onChange, buttonText, buttonClickHandler, disabled, }) {
    const [newValues, setNewValues] = (0, react_1.useState)([min, max]);
    const [values, setValues] = (0, react_1.useState)([min, max]);
    const setValue = (e) => {
        setNewValues((prev) => {
            let items = [...prev];
            items[e.target.name] = +e.target.value;
            return items;
        });
    };
    const checkValues = () => {
        const nextValue = [
            Math.max(Math.min(newValues[0], newValues[1]), min),
            Math.min(Math.max(newValues[0], newValues[1]), max),
        ];
        setValues(nextValue);
        setNewValues(nextValue);
    };
    const setOutValues = () => {
        buttonClickHandler(values);
    };
    (0, react_1.useEffect)(() => {
        if (incomeValues) {
            setValues(incomeValues);
            setIncomeValue && setIncomeValue(null);
        }
    }, [incomeValues]);
    (0, react_1.useEffect)(() => {
        setNewValues(values);
        onChange && onChange(values);
    }, [values]);
    const isDisabled = min === max || disabled;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(range_styled_1.RangeContainer, null,
            react_1.default.createElement(vobaza_ui_inputs_input_text_1.InputText, { label: "\u041E\u0442", name: "0", value: newValues[0].toString(), onChange: setValue, onBlur: checkValues, valueType: "integer", disabled: isDisabled }),
            react_1.default.createElement(vobaza_ui_inputs_input_text_1.InputText, { label: "\u0414\u043E", name: "1", value: newValues[1].toString(), onChange: setValue, onBlur: checkValues, valueType: "integer", disabled: isDisabled })),
        !isDisabled && (react_1.default.createElement(react_range_1.Range, { step: step, min: min, max: max, values: values, onChange: setValues, renderTrack: ({ props, children }) => (react_1.default.createElement(range_styled_1.RangeTrack, Object.assign({}, props), children)), renderThumb: ({ props }) => react_1.default.createElement(range_styled_1.RangeDot, Object.assign({}, props)) })),
        buttonText && buttonClickHandler && (react_1.default.createElement(range_styled_1.RangeButtonWrapper, null,
            react_1.default.createElement(vobaza_ui_button_1.Button, { text: buttonText, onClick: setOutValues, disabled: isDisabled })))));
}
exports.RangeBlock = RangeBlock;
//# sourceMappingURL=range.js.map